import React, { useContext, useEffect } from "react";
import { GiHamburgerMenu } from 'react-icons/gi';
import { FaArrowLeft } from 'react-icons/fa';
import { IoMdAdd } from 'react-icons/io';
import DashboardContext from "../contexts/dashboardContext";
import NavKey from "../reducerKeys/navbarKey.json";
import Paths from "../config/paths.json";
import Storages from "../helper/storages";
import { useNavigate, matchRoutes, useLocation } from "react-router-dom";

export default function Navbar(props) {
    const dContext = useContext(DashboardContext)
    const navigate = useNavigate();
    const location = useLocation()
    var avatar = require(`../assets/images/${process.env.REACT_APP_ENV}/logo.png`)

    var openToggleMenu = () => {
        // props.click()
        console.log('sdddddddddddddddddddddddd',dContext.isOpen)
        if (dContext.isOpen)
            dContext.setOpen(false);
        else
            dContext.setOpen(true);

        // dContext.navDispatch({ type: NavKey.toggleClick, value: !dContext.navState.isOpen })
    }

    var onBackPress = () => {
        navigate(-1)
    }

    var onProfilePress = () => {
        navigate(Paths.profile)
    }

    // var linkToPaySlip = () => {
    //     navigate(Paths.paySlip)
    // }

    return (
        <div className="col-12 bg-dark justify-content-end align-items-center ps-3 d-flex flex-row sticky-top" style={{ height: '60px' }}>


            {/* {location.pathname == Paths.expertReceipts ?
                <div className="h-100 ms-auto d-flex flex-row justify-content-end align-items-center" onClick={linkToPaySlip}>
                    <IoMdAdd className=' me-3 text-warning' size={30} />
                    <h2 className="coName m-0   me-2 text-warning" >افزودن فیش جدید</h2>
                </div> :
                <></>
            } */}

            {location.pathname == Paths.dashboard ? <>
                <div className="d-flex flex-row justify-contents-center align-items-center ms-auto me-3" onClick={onProfilePress}>
                    <img src={avatar} style={{ width: "2rem" }} />

                    <p className='text-light bold iranSansBold ps-3 pe-3 coName m-0' >{Storages?.getUserInfo()?.name}</p>

                </div>

                <p onClick={openToggleMenu} className='text-light bold iranSansBold ps-3 pe-3 coName m-0' >پنل ثبت سرویس</p>
                <GiHamburgerMenu className='h-100 ' color='#fff' size={30} onClick={openToggleMenu} />

            </> :
                <>
                    <FaArrowLeft onClick={onBackPress} className='h-100  me-3 ' color='#fff' size={25} />
                </>

            }

        </div>
    )
}